<template>
    <div class="licenses wrapper">
        <div class="license-key-container flex">
            <div class="license-key">
                <div class="license-key-scroll-wrapper">
                    {{ license.key }}
                </div>
            </div>
            <div
                :class="'copy-btn-'+index"
                class="copy-btn"
            >
                <i class="fal fa-copy" />
                Copy
                <base-tooltip>
                    Copied!
                </base-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
import ClipboardJS from 'clipboard';

export default {
    props: {
        /* eslint-disable vue/require-default-prop */
        license: Object,
        index: Number,
        /* eslint-enable */
    },

    /**
     * Created hook
     */
    created() {
        this.handleClipboard();
    },
    methods: {
        /**
         * Handles copy to clipboard
         *
         */
        handleClipboard() {
            new ClipboardJS('.copy-btn', {
                // eslint-disable-next-line require-jsdoc
                target: function (trigger) {
                    trigger.lastChild.classList.add('active');

                    setTimeout(() => {
                        trigger.lastChild.classList.remove('active');
                    }, 1500);
                },
                // eslint-disable-next-line require-jsdoc
                text: function (trigger) {
                    return trigger.previousSibling.previousElementSibling.innerText;
                },
            });
        },
    },
};
</script>
